module.exports = __webpack_public_path__ + "static/fonts/iconfont.988852c7.ttf";